import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import './styles/InterestDetail.css';

const InterestDetail = () => {
  const { state: interest } = useLocation();

  if (!interest) {
    return <div>Interest details not found.</div>;
  }

  return (
    <main className="interest-detail">
      <h1>{interest.name}</h1>
      <p>{interest.full}</p>
      <div className="interest-links">
        {interest.link1 && (
          <a
            href={interest.link1}
            target="_blank"
            rel="noopener noreferrer"
          >
            Link 1
          </a>
        )}
        {interest.link2 && (
          <a
            href={interest.link2}
            target="_blank"
            rel="noopener noreferrer"
          >
            Link 2
          </a>
        )}
      </div>
      <Link to="/interests">← Back to Interests</Link>
    </main>
  );
};

export default InterestDetail;
